import React from 'react';

//-----------------------------------------------------------------------------------------
// Public Components:
//-----------------------------------------------------------------------------------------

export default function DisabledOverlay() {

	// displays loading spinner in front of all elements preventing user from interacting with the DOM.
	return (
		<div className="disable-overlay">
			<svg width="50px" height="50px" viewBox="0 0 50 50" xmlns="http://www.w3.org/2000/svg" fill="none">
				<circle cx="25" cy="25" r="20" stroke="#B78E5F" strokeWidth="4" strokeLinecap="round" fill="none" key="" strokeDasharray="100" strokeDashoffset="0">
					<animateTransform attributeName="transform" type="rotate" from="0 25 25" to="360 25 25" dur="1s" repeatCount="indefinite" />
					<animate attributeName="stroke-dashoffset" values="0;200" dur="1s" repeatCount="indefinite" />
				</circle>
			</svg>
		</div>
	);
}
